"use client";
import { Button } from "@/components/ui/button";
import TrendingUpIcon from "@heroicons/react/24/solid/ArrowTrendingUpIcon";
import ChatBubbleLeftRightIcon from "@heroicons/react/24/solid/ChatBubbleLeftRightIcon";
import StarIcon from "@heroicons/react/24/solid/StarIcon";
import { useSite } from "@/lib/hooks/site";
import { useState } from "react";
import VenueCardNoImg from "@/components/views/list/card/VenueCardNoImg";
import S3Image from "@/components/S3Image";
import { useTranslation } from "@/hooks/translationContext";

export default function YourRivalIsHere() {
  const { t } = useTranslation()
  const site = useSite();
  const [error, setError] = useState(false);

  const thirdPhoto = site.setting?.design?.addVenue?.hero?.thirdPhoto?.["1"];

  return (
    <div className="w-full py-[40px] bg-white flex justify-center">
      <div className="container w-full flex gap-6 lg:flex-row flex-col-reverse items-center">
        {!thirdPhoto || error ? (
          <div className=" h-[377px] md:h-full w-[366px] md:w-[506px] object-cover object-center">
            <VenueCardNoImg type={0} />
          </div>
        ) : (
          <S3Image
            width={0}
            height={0}
            src={`site/${site.id}/assets/${thirdPhoto}`}
            sizes="(max-width: 600px) 366px,
                         506px"
            className="rounded-[24px] h-[377px] md:h-full w-[366px] md:w-[506px] object-cover object-center"
            alt={`${site.descriptions[0]?.title} ~ ${t("venue-add-title", { defaultValue: "Mekan Ekle" })}`}
            onError={() => {
              setError(true);
            }}
          />
        )}

        <div className="flex flex-col lg:h-[508px] max-lg:gap-6 lg:items-end  w-full justify-between">
          <div className="flex w-full flex-col justify-start lg:justify-end lg:items-end gap-6">
            <h2 className="text-primary font-bold text-2xl lg:text-[32px]">
              {t("add-venue-page-fifth-section-title", {
                defaultValue: `Tüm Rakipleriniz Burada! Öne Çıkın.`
              })}
            </h2>

            <div className="lg:text-right lg:w-[488px]">
              <p className="text-assistant text-sm lg:text-base font-bold">
                {t("add-venue-page-fifth-section-description", {
                  defaultValue: `Rakipleriniz işlerini burada büyütüyor. Siz de ${site.domain}’a
                işletmenizi kaydedin, rakiplerinizin gerisinde kalmayın!`
                })}
              </p>
            </div>

            <div className="flex flex-wrap lg:justify-end gap-4">
              <div className="shadow text-assistant rounded-full bg-white py-1.5 px-2 flex gap-2 items-center font-medium text-xs">
                <StarIcon className="size-6 text-secondary" />

                <h3>Yüzlerce işletme arasında öne çıkın</h3>
              </div>

              <div className="shadow text-assistant rounded-full bg-white py-1.5 px-2 flex gap-2 items-center font-medium text-xs">
                <TrendingUpIcon className="size-6 text-secondary" />

                <h3>Görünür olun</h3>
              </div>

              <div className="shadow text-assistant rounded-full bg-white py-1.5 px-2 flex gap-2 items-center font-medium text-xs">
                <ChatBubbleLeftRightIcon className="size-6 text-secondary" />

                <h3>Reklam verin</h3>
              </div>
            </div>
          </div>

          <Button
            onClick={() => {
              window.scrollTo({
                top: 0,
              });
            }}
            className="bg-[#15BBAE] w-[143px] hover:bg-[#15BBAE] flex"
          >
            {t("venue-add-title")}
          </Button>
        </div>
      </div>
    </div>
  );
}
